<template>
    <div class="homepage">
        <div v-wechat-title="$route.meta.title"></div>
        <p v-if="Loading" class="details_page" style="text-align: center;line-height:160px"><mt-spinner
                type="triple-bounce"></mt-spinner></p>
        <div v-if="!Loading" class="details_page">
            <p class="details_title">{{ listParameter.title }}</p>
            <div class="details_content">
                <div class="details_content_left">
                    <p class="details_years"><span>──</span> {{ releaseYears }}<span>──</span></p>
                    <div class="details_date">
                        <span class="details_month">{{ releaseMonth }}</span>
                        <span class="details_day">{{ releaseDay }}</span>
                    </div>
                    <p class="details_time">{{ releaseTime }}</p>
                    <p class="details_nav"><span>{{ listParameter.source }}</span></p>
                    <div class="details_app">
                        <img src="./img/puyang.jpg" alt="">
                        <!-- <el-image src="./img/puyang.jpg"  lazy></el-image> -->
                        <p class="details_app_name">云上濮阳</p>
                        <p class="details_app_cli">新闻客户端</p>
                    </div>
                </div>
                <span class="details_content_border"></span>
                <div class="details_content_right">
                    <!-- 外链直接用 iframe 打开链接本身 -->
                    <iframe v-if="urlHrefIf" :src="urlHref" frameborder="0" style="height:420px;width:100%"></iframe>
                    <div v-if="!urlHrefIf">
                        <!-- 正常视频播放使用 video.js 播放器 -->
                        <video
                            v-if="videoSrc && !videoBlockedMessage"
                            id="my-video"
                            ref="myVideo"
                            class="video-js vjs-default-skin imgs myVideo-dimensions"
                            controls
                            preload="auto"
                            :poster="listParameter.img_cut_url">
                            <source
                                :src="videoSrc"
                                :type="videoMimeType">
                        </video>
                        <div v-if="videoBlockedMessage" class="video_error_message">{{ videoBlockedMessage }}</div>
                        <p id="list_details" v-html="listParameter.content"></p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { listDetails, generateSign } from '@/api/index'
import videojs from 'video.js'
import 'videojs-contrib-hls'


const listDetailsParameter = {
    type: 1,
    data: "https://puyang.wengegroup.com/activities/a/202004/01/WS5e83eaafe4b0b0c42ff56db9.json",
    userId: "",
    appInfoId: "10"
}
export default {
    data() {
        return {
            Loading: true,
            detailsParameter: Object.assign({}, listDetailsParameter),
            listParameter: '',
            releaseYears: null,
            releaseMonth: null,
            releaseDay: null,
            releaseTime: null,
            isBanner: true,// 是否显示banner图
            isVideo: true,// 是否显示视频
            titleifer: '',
            urlHref: '',
            urlHrefIf: false,
            videoUrlIf: false,
            videoUrlIfsert: false,
            // 播放使用的地址：优先使用 properties.publishMp4Url
            videoSrc: '',
            // 根据后缀判断使用的 mimeType（m3u8 或 mp4）
            videoMimeType: 'video/mp4',
            // video.js 播放器实例，避免重复初始化
            videoPlayer: null,
            // 无法播放时给用户看的提示
            videoBlockedMessage: ''

        }
    },
    created() {
        this.detailsParameter.id = this.$route.query.id
        this.details()

    },
    mounted() {


    },
    methods: {

        async details() {
            const headers = {
                'Sign': generateSign()
            };
            const res = await this.axios.post(listDetails, this.detailsParameter, { headers })

            if (res.data.data[0].stroyType == 'HREF') {
                this.urlHref = res.data.data[0].url
                this.urlHrefIf = true
            }

            this.listParameter = res.data.data[0]
            this.releaseYears = res.data.data[0].pubDate.split('-')[0]
            this.releaseMonth = res.data.data[0].pubDate.split('-')[1]
            this.releaseDay = res.data.data[0].pubDate.split('-')[2].split('T')[0]
            this.releaseTime = res.data.data[0].pubDate.split('-')[2].split(' ')[1]

            // 取视频播放地址：优先使用 accessUrl，否则回退到 video_url
            const accessUrl = (this.listParameter.properties && this.listParameter.properties.accessUrl)
                ? this.listParameter.properties.accessUrl
                : '';
            this.videoSrc = accessUrl || this.listParameter.video_url || '';
            this.videoBlockedMessage = ''
            if (this.videoSrc.indexOf('http://') === 0) {
                this.videoSrc = this.videoSrc.replace('http://', 'https://')
            }

            let videoIf = (this.videoSrc || '').split('.')
            let videoSuffixIf = videoIf[videoIf.length - 1]
            // 根据后缀设置 mimeType
            if (videoSuffixIf === 'm3u8') {
                this.videoMimeType = 'application/x-mpegURL'
            } else {
                this.videoMimeType = 'video/mp4'
            }

            if (this.videoSrc != "" && videoSuffixIf != 'm3u8') {

                if (videoIf.length > 1) {
                    this.videoUrlIfsert = true
                }
                this.videoUrlIf = true
            }
            if (videoIf.length > 1) {
                this.videoUrlIfsert = true
            }

            // 初始化 video.js 播放器（有视频地址时）
            if (this.videoPlayer) {
                this.videoPlayer.dispose()
                this.videoPlayer = null
            }

            this.Loading = false

            if (this.videoSrc && !this.videoBlockedMessage) {
                this.$nextTick(() => {
                    if (!this.$refs.myVideo) {
                        return
                    }
                    this.videoPlayer = videojs(this.$refs.myVideo, {
                        textTrackDisplay: false,
                        posterImage: true,
                        errorDisplay: false,
                        controlBar: true,
                        hls: {
                            withCredentials: true
                        }
                    }, function () {
                        // 不自动播放
                    })
                })
            }
        },

    },
    beforeDestroy() {
        if (this.videoPlayer) {
            this.videoPlayer.dispose()
            this.videoPlayer = null
        }
    }
}
</script>
<style lang="">




.video-js{
  width: 100% !important;
  min-height:500px !important;
}

.video-js .vjs-big-play-button {
  z-index: 9999;
  display:block;
  font-size: 3em;
  line-height: 42px!important;
  height: 50px!important;
  width: 50px!important;
  position: absolute!important;
  left:50%!important;
  top:50%!important;
  margin-top:-25px!important;
  margin-left:-25px!important;
  padding: 0;
  cursor: pointer;
  opacity: 1;
  border: 0.06666em solid #fff;
  background-color: #2B333F;
  background-color: rgba(43, 51, 63, 0.7);
  border-radius: 50%!important;
  -webkit-transition: all 0.4s;
  transition: all 0.4s;
}
.vjs-paused .vjs-big-play-button,
.vjs-paused.vjs-has-started .vjs-big-play-button {
    display: block!important;
}
.vjs-playing .vjs-big-play-button {
    display: none!important;
}
.myVideo-dimensions {
  width: 100%!important;
  height: 100%!important;
  display: block!important;
}
.vjs-poster{
  background-size: 100% 100%!important;
}
.video_error_message{
  width: 100%;
  min-height: 120px;
  padding: 24px;
  box-sizing: border-box;
  line-height: 28px;
  font-size: 16px;
  color: #c62828;
  background: #fff5f5;
  border: 1px solid #f3c3c3;
  border-radius: 6px;
}













    #list_details figure img{
        max-width:100%;
    }
    #list_details ul li img{
        max-width:100%;
    }
    #list_details p{
        font-size:16px !important;
        line-height:30px !important;
        color:rgb(34, 34, 34);
        font-family: 宋体;
    }
    #list_details div img{
        max-width:100%;
    }
    #list_details p img{
        max-width:100%;
    }
    #list_details div{
        font-size:16px !important;
        line-height:30px !important;
        color:rgb(34, 34, 34);
        font-family: 宋体;
    }
    #list_details p span{
        font-size:16px !important;
        line-height:30px !important;
        color:rgb(34, 34, 34);
        font-family: 宋体;
    }
    #list_details div span{
        font-size:16px !important;
        line-height:30px !important;
        color:rgb(34, 34, 34);
        font-family: 宋体;
    }
    #list_details p span img{
        max-width:100%;
    }
    #list_details div span img{
        max-width:100%;
    }

    .homepage{
        display:absolute;
        margin-top:20px;
        width:1200px;
        margin:0 auto;
        /* -moz-box-shadow:0 0 10px rgb(239, 239, 240);
        -webkit-box-shadow:0 0 10px rgb(206, 206, 209);
        box-shadow:0 0 10px rgb(184, 184, 187); */
        background:#ffffff;
    }
    .details_page{
        min-height:calc(100vh - 241px) !important;
        padding:47px 28px 0;
    }
    .details_page .details_title{
        font-size: 30px;
        min-height:28px;
        line-height:40px;
        border-left:6px solid #D23B2A;
        font-weight: 600;
        margin:0 0 34px 55px;
        padding-left:10px;
        color:rgba(26,26,26,1);
    }
    .details_content{
        border-top:1px solid rgba(220,220,220,1);
        padding-top:34px;
        display:flex;
        padding-bottom:60px;
        justify-content: baseline;
    }
    .details_content .details_content_left{
        width:128px;
        float:left;
        height:412px;
        padding-left:54px;
    }
    .details_content_left .details_years{
        width:93px;
        font-size: 16px;
    }
    .details_content_left .details_years span{
        color:#E5E5E5;
    }
    .details_content_left .details_date{
        margin-top:10px;
        width:93px;
        height:93px;
        position:relative;
        background:url(./img/data.png) no-repeat;
        background-size: 100% 100%;
    }
    .details_content_left .details_date span{
        font-size: 30px;
        color:#1A1A1A;
    }
    .details_content_left .details_date .details_month{
        position:absolute;
        top:42px;
        left:6px;
    }
    .details_content_left .details_date .details_day{
        position:absolute;
        top:42px;
        right:6px;
    }
    .details_time{
        height:40px;
        line-height: 40px;
        padding-left: 8px;
        color:#1A1A1A;
        font-size: 20px;

    }
    .details_nav span{
        width:90px;
        height:24px;
        border-radius: 12px;
        display: block;
        text-align: center;
        background:#D23B2A;
        color:#ffffff;
        font-size: 16px;
        line-height: 24px;
    }
    .details_app{
        padding-top:46px;
    }
    .details_app img{
        width:91px;
        height:91px;
    }
    .details_app p{
        color:#1A1A1A;
        font-size: 14px;
        line-height: 22px;
    }
    .details_app .details_app_name{
        padding-left: 16px;
    }
    .details_app .details_app_cli{
        padding-left: 8px;
    }

    .details_content_border{
        width:6px;
        float:left;
        height:412px;
        border-radius: 3px;
        background: #DCDCDC;
    }
    .details_content .details_content_right{
        font-size:0.25rem;
        color:rgba(161,161,161,1);
        line-height:30px;
        width:880px;
        display:flex;
        flex-direction: column;
        margin-left:44px;
    }
    .details_content .details_content_rights{
        font-size:0.25rem;
        color:rgba(161,161,161,1);
        line-height:30px;
        width:880px;
        float:left;
        margin-left:44px;
    }

</style>



// WEBPACK FOOTER //
// src/components/details/index.vue